var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/User/User/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 7.33333C9.47269 7.33333 10.6666 6.13943 10.6666 4.66667C10.6666 3.19391 9.47269 2 7.99994 2C6.52718 2 5.33327 3.19391 5.33327 4.66667C5.33327 6.13943 6.52718 7.33333 7.99994 7.33333Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.5334C2 10.551 4.41766 8.13337 7.4 8.13337H8.6C11.5823 8.13337 14 10.551 14 13.5334V13.6C14 13.8209 13.8209 14 13.6 14C13.3791 14 13.2 14 13.2 14C13.2 14 11.1405 14 8.6 14H7.4C4.85949 14 2.8 14 2.8 14C2.8 14 2.62091 14 2.4 14C2.17909 14 2 13.8209 2 13.6V13.5334Z",
    fill: "#5B5C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipUser);
export default __webpack_public_path__ + "static/media/chipUser.e3a8b4ec04afd92b626ed156c4b2f6c0.svg";
export { ForwardRef as ReactComponent };